<template>
  <div id="returncreditct" class="contentmodaldiv" data-backdrop="false">
    <div class="modaldiv">
      <div class="contentmodal animate__animated animate__bounceInDown">
        <button class="closepopup" data-dismiss="modal">
          <i class="fas fa-times"></i>
        </button>
        <div class="login">
          <div class="logopopup">
            <img src="/static/img/logo/main_logo_20221004223046.png" />
          </div>
          <h1 class="walletTitle">คืนยอดเสีย</h1>

          <div id="accordion">
            <div class="card bonusCard">
              <div
                id="collapseOne"
                aria-labelledby="headingOne"
                data-parent="#accordion"
                class="collapse show"
                style="display: block;"
              >
                <div class="card-body">
                  <div class="text-center">
                    <h6>โบนัสคืนยอดเสียคงเหลือ</h6>
                    <h2 class="creditNum">
                      <i class="fas fa-redo-alt cursor-pointer"></i>
                      <span class="">{{
                        UserInfo.internalWallet.cashbackWallet
                      }}</span>
                    </h2>

                    <span class="text-warning mb-2 mt-0"
                      >คืนยอดเสีย {{ Prefix.cashBack.Payout }} % </span
                    >
                    <a
                      href="javascript:void(0)"
                      class="btnTransfer"
                      @click="getRolling()"
                      >รับ CASHBACK</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlaymodal"></div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { PrefixMixins } from "@/mixins/Prefix.js";

import { fetchCaskback, Rolling } from "@/services/modules/cashback.js";
import moment from "moment";

export default {
  name: "CashBackForm",
  mixins: [UserInfoMixins, PrefixMixins],

  data() {
    return {
      CashBackHistory: [],
    };
  },

  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },
  methods: {
    getDate: function(data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },

    async getRolling() {
      await Rolling(this.UserInfo.internalWallet.cashbackWallet, (res) => {
        if (res.status) {
          this.$swal.fire("Success!", "", "success");
        } else {
          this.$swal.fire(res.message, "", "error");
        }
      });
    },
    async fetchDeposit() {
      await fetchCaskback((res) => {
        if (res.status) {
          this.CashBackHistory = res.data;
        }
      });
    },
  },
  async mounted() {
    await this.fetchDeposit();
    $(".overlaymodal").on("click", function() {
      $("#returncreditct").modal("hide");
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/CashBackForm.vue